module.exports = __webpack_public_path__ + "img/vafler_serve.8b1d0595.jpg";